import React from 'react'
import { useSelector } from 'react-redux'
import useStyles from './styles'
import Sidebar from '../../../components/Topbar/Topbar'
import Screen1 from 'pages/Dashboard/HomeSevenScreen/screens/screen1/Screen1'
import Screen2 from 'pages/Dashboard/HomeSevenScreen/screens/screen2/Screen2'
import Screen3 from 'pages/Dashboard/HomeSevenScreen/screens/screen3/Screen3'
import Screen4 from 'pages/Dashboard/HomeSevenScreen/screens/screen4/Screen4'
import Screen5 from 'pages/Dashboard/HomeSevenScreen/screens/screen5/Screen5'
import Screen6 from 'pages/Dashboard/HomeSevenScreen/screens/screen6/Screen6'
import Screen7 from 'pages/Dashboard/HomeSevenScreen/screens/screen7/Screen7'

const SevenScreen = () => {
    const { isHorizontal } = useSelector((state) => state.app)
    const classes = useStyles()

    return (
        <div
            className={
                isHorizontal
                    ? classes.mainContainerHorizontal
                    : classes.mainContainerVertical
            }
        >
            <Sidebar />
            <div
                className={
                    isHorizontal
                        ? classes.screenHorizontal
                        : classes.screenVertical
                }
            >
                <Screen1 />
            </div>
            <div
                className={
                    isHorizontal
                        ? classes.screenHorizontal
                        : classes.screenVertical
                }
            >
                <Screen2 />
            </div>
            <div
                className={
                    isHorizontal
                        ? classes.screenHorizontal
                        : classes.screenVertical
                }
            >
                <Screen3 />
            </div>
            <div
                className={
                    isHorizontal
                        ? classes.screenHorizontal
                        : classes.screenVertical
                }
            >
                <Screen4 />
            </div>
            <div
                className={
                    isHorizontal
                        ? classes.screenHorizontal
                        : classes.screenVertical
                }
            >
                <Screen5 />
            </div>
            <div
                className={
                    isHorizontal
                        ? classes.screenHorizontal
                        : classes.screenVertical
                }
            >
                <Screen6 />
            </div>
            <div
                className={
                    isHorizontal
                        ? classes.screenHorizontal
                        : classes.screenVertical
                }
            >
                <Screen7 />
            </div>
        </div>
    )
}

export default SevenScreen
